var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"speaker-test add-margin-top-v2"},[_c('button',{staticClass:"zawa-popup__popup-button setting-button",on:{"click":function($event){_vm.isPlaying ? _vm.stopTest() : _vm.playTest()}}},[_vm._v(" "+_vm._s(_vm.isPlaying ? '停止' : 'スピーカーをテスト')+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }